export default {
  name: "Language",

  data(){
    return{
      activeLang: 'en'
    }
  }
}